import { forwardRef } from 'react'
import { createPath, Link as RouterLink, type LinkProps } from 'react-router-dom'
import { siteHref } from '@utils/appDomain'

export const AppLink = forwardRef<HTMLAnchorElement, LinkProps>(function AppLink({ to, reloadDocument, ...props }, ref) {
  const originalPath = typeof to === 'string' ? to : to.pathname?.startsWith('/') ? createPath(to) : null
  const mappedPath = originalPath === null ? null : siteHref(originalPath)
  const target = mappedPath !== null && mappedPath !== originalPath ? mappedPath : to
  const absolute = typeof target === 'string' && /^https?:\/\//i.test(target)
  return <RouterLink {...props} ref={ref} to={target} reloadDocument={reloadDocument || absolute} />
})